import { createAction } from 'redux-actions';
import ActionTypes from '../constants/ActionTypes';
import { supo, hipNew, register, RegisterFields } from '../api';
import { SubmissionError } from 'redux-form';
import qs from 'query-string';
import { getToken, getUserLoginState } from '../selectors/user';
import { fetchFeed } from './feed';

const onSuccess = createAction(ActionTypes.USER_LOGIN_CHECK_SUCCESS);

const setPasswordSuccess = createAction(ActionTypes.SET_PASSWORD_SUCCESS);
const setPasswordError = createAction(ActionTypes.SET_PASSWORD_ERROR);
const facebookConnectSuccess = createAction(ActionTypes.FACEBOOK_CONNECT_SUCCESS);

export const onLoginCheckSuccess = data => dispatch => {
  dispatch(onSuccess(data));
};

//set password for the first time - api only works if there is no user-created password set already
export const setPassword = data => async dispatch => {
  try {
    const response = await hipNew.post('/api/success/set-password', data);
    if (response.data.success) {
      const userInfo = await hipNew.get('/system/ajax_handlers/user_info.php');
      dispatch(onLoginCheckSuccess(userInfo.data));
      dispatch(setPasswordSuccess());
    } else {
      dispatch(setPasswordError());
    }
  } catch (e) {
    if (e.response.data.errors) {
      throw new SubmissionError(e.response.data.errors);
    }
  }
};

const isSignUpSuccess = response => {
  const { status, data } = response;
  return status === 200 && data.success;
};

export const setToken = token => dispatch => {
  dispatch({ type: ActionTypes.USER_SET_JWT, payload: token });
};

export const setId = id => dispatch => {
  dispatch({ type: ActionTypes.USER_SET_ID, payload: id });
};

export const signUp = (formData: Partial<RegisterFields>) => async dispatch => {
  try {
    const response = await register(formData);
    if (isSignUpSuccess(response)) {
      dispatch({ type: ActionTypes.USER_SIGNUP_SUCCESS });
    } else {
      dispatch({ type: ActionTypes.USER_SIGNUP_ERROR });
      dispatch({ type: ActionTypes.USER_SIGNUP_ERROR_INFO, payload: formData });
      const { success, error } = response.data;
      if (success === false) {
        dispatch({ type: ActionTypes.USER_SIGNUP_MESSAGE, payload: error });
      }
    }
  } catch (e) {
    dispatch({ type: ActionTypes.USER_SIGNUP_ERROR });
  }
};

export const login = (data, link) => async dispatch => {
  try {
    const response = await hipNew.post('/system/ajax_handlers/login.php', data);
    if (response.status === 200) {
      window.location = link;
    } else {
      dispatch({ type: ActionTypes.USER_LOGIN_ERROR, payload: true });
    }
  } catch (e) {
    dispatch({ type: ActionTypes.USER_LOGIN_ERROR, payload: true });
  }
};

export const getLoginInfo = async dispatch => {
  const userInfo = await hipNew.get('/system/ajax_handlers/user_info.php');
  dispatch(onLoginCheckSuccess(userInfo.data));
};

export const checkLoginInfo = () => dispatch => {
  getLoginInfo(dispatch);
};

//reset an existing password (eg. if you've forgotten it) - requires token
export const resetPassword = data => async (dispatch, getState) => {
  const state = getState();
  const { location } = state.router;
  if (!location) return;
  const query = qs.parse(location.search);
  if (query.token) {
    try {
      const response = await hipNew.post(
        `/api/success/reset-unknown-password?token=${query.token}`,
        data
      );
      if (response.data.success) {
        const userInfo = await hipNew.get('/system/ajax_handlers/user_info.php');
        dispatch(onLoginCheckSuccess(userInfo.data));
        dispatch(setPasswordSuccess());
      } else {
        dispatch(setPasswordError());
      }
    } catch (e) {
      if (e.response.data.errors) {
        throw new SubmissionError(e.response.data.errors);
      }
    }
  } else {
    //no token in url
    dispatch(setPasswordError());
  }
};

export const connectFacebook = () => async dispatch => {
  dispatch(facebookConnectSuccess());
};

export function extractTokenFromUrl() {
  return (dispatch, getState) => {
    const state = getState();
    const { location } = state.router;
    if (!location) return;
    const query = qs.parse(location.search);
    if (query.token) {
      dispatch({ type: ActionTypes.USER_SET_JWT, payload: query.token });
    }
  };
}

export function updateLocation(values, currentFilter) {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    const user = getUserLoginState(getState());
    // TODO ERROR HANDLING
    await supo.put(
      `/user/${user.id}/location`,
      {
        postcode: values.postcode,
        suburbId: values.id
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    dispatch({ type: ActionTypes.CLEAR_FEEDS });
    dispatch(checkLoginInfo());
    dispatch(fetchFeed(currentFilter));
  };
}
